const GuidesLevel2: React.FC = () => {
  return (
    <div className="featured-articles-container">
      <p>
        <a href="/" className="breadcrumb-link">
          Help Desk
        </a>{" "}
        &#10132;{" "}
        <a href="/guides" className="breadcrumb-link">
          Guides
        </a>{" "}
        &#10132; Level 2 trading guide
      </p>
      <h2 className="help-heading">Level 2 trading guide</h2>
      <p>
        Level 2 data is accessible with a CEO PRO membership. This can be
        purchased when you sign up for a new account; existing users can sign up{" "}
        <a href="https://ceo.ca/about/market-depth">here</a>.
      </p>
      <p>
        Our real-time market depth program offers interactive Level-2 quotes,
        providing CEO.CA users with unparalleled market access to give you a
        leading edge and extra insight into a public security stock order book.
        Level 2 data is the order book for that stock, also known as market
        depth. The order book indicates all open bids and offers or in other
        words, how many shares and at what price buyers are willing to pay and
        how many shares and at what price sellers are willing to sell at. CEO.CA
        Level-2 quotes are built directly within the CEO.CA platform on each
        security page. Users can continue to interact with the community while
        reviewing quotes for their favourite stocks. When reviewing Level-2
        quotes you will see<b> Market By Price </b>and <b>Market By Order</b>.
        Each has a window with two sections. The first in red for ask/sell and
        the second in green for bid/buy.
      </p>
      <img
        src={require("../../../assets/nav-article-12.png")}
        alt="level-article-1"
        className="basic-article-1"
      />
      <img
        src={require("../../../assets/nav-article-13.png")}
        alt="level-article-2"
        className="basic-article-1"
      />
      <p>
        The bid/buy section is shown in green on the bottom and represents
        traders looking to buy the stock at certain prices. The tables show the
        number of shares that buyers are looking to purchase at various prices.
        Bids are arranged in descending order, with the highest bids listed at
        the top of the green section.
      </p>
      <img
        src={require("../../../assets/nav-article-7.png")}
        alt="level-article-3"
        className="basic-article-1"
      />
      <p>
        The red section at the top of each table represents the ask/sells,
        highlighting the traders that are looking to sell the stock at certain
        prices. Again, this shows the number of shares that sellers are looking
        to sell at various prices. Asks are arranged inversely to bids in
        ascending order with the lowest ask at the bottom and the highest at the
        top.
      </p>
      <i>What are the benefits of Level 2?</i>
      <p>
        Stock activity in real-time – stop waiting 15 minutes to find out you
        missed the trading opportunity of a lifetime. Get real-time trading
        updates directly from your CEO.CA platform. Stock activity in real-time
        – stop waiting 15 minutes to find out you missed the trading opportunity
        of a lifetime. Get real-time trading updates directly from your CEO.CA
        platform.
      </p>
      <p>
        Look behind the curtain to identify buying/selling action – assess
        retail/institutional trading patterns by reviewing market participant
        trading activity. See trends and opportunities before the stock reacts
        on the open market.
      </p>
      <p>
        Review order sizes – see which way the bids/asks are trending and get
        ahead of the curve.
      </p>
      <p>
        Make informed decisions – do not trade in the dark. Top traders use the
        best information available to buy or sell stocks. Get the information
        you need and start your CEO PRO subscription today.{" "}
      </p>
      <p>
        Level 2 data is accessible with a CEO PRO membership. This can be
        purchased when you sign up for a new account; existing users can sign up{" "}
        <a href="https://ceo.ca/about/market-depth">here</a>.
      </p>
    </div>
  );
};

export default GuidesLevel2;
